import { $sceneId } from '../state/appState';

/**
 * Current scene id as a string snapshot (null if unset). Shared by the
 * analytics trackers that tag events with the scene the user is on.
 */
export const currentSceneId = (): string | null => {
  const v = $sceneId.getState();
  return v == null ? null : String(v);
};
